import { createFileRoute } from '@tanstack/react-router';

import { BookingsListPage } from '@/features/midoffice/operations/BookingsListPage';

export const Route = createFileRoute('/midoffice/')({
	component: BookingsListPage,
});
